import { GeoMonster } from 'root/utils/cookies/geoMonster';
const toggleDisplayDoNotSellButtonByLocation = () => {
    const doNotSellFooterButton = document.querySelector('#ot-sdk-btn');
    const gm = new GeoMonster();
    const { country_code = 'US', state_code = 'NY' } = gm.getCookie('geoConfig');
    if (country_code !== 'US' && state_code !== 'CA') {
        if (doNotSellFooterButton) {
            doNotSellFooterButton.classList.add('tw:hidden');
        }
    }
};

export { toggleDisplayDoNotSellButtonByLocation };
